import React from "react";
import styles from "src/components/atoms/Check/styles.module.css";
import CheckIcon from "src/assets/icons/checkRound.svg";
type Props = {
  isCheck?: boolean;
  onChange: () => void;
};

export const Check: React.FC<Props> = ({ isCheck, onChange }) => (
  <div className={styles.check} role="button" onClick={onChange}>
    {isCheck ? <img src={CheckIcon} alt="check" /> : <div />}
  </div>
);
